import { styles } from './template.scss';
import { styles as textHelpersStyles } from './../../assets/text-helpers.scss';
import { styles as colorHelpersStyles } from './../../assets/color-helpers.scss';

export const templateMspEdrTrialReport = document.createElement('template');

templateMspEdrTrialReport.innerHTML = `
  <style>${textHelpersStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">
    <div class="page page-1">
        <div class="cover-content">
            <div class="bitdefender-logo"></div>
            <h1>EDR Trial report</h1>
            <h2 id="client-name">Client name goes here</h2>
            <h4>Reporting interval: <br><span id="reporting-period"></span></h4>
        </div>
        <div class="bitdefender-logo-b">
          <?xml version="1.0" encoding="UTF-8"?>
          <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 610.72 610.72">
            <defs>
              <style>
                .cls-1 {
                  fill: none;
                  stroke: var(--white-layout-300-primary);
                  stroke-miterlimit: 10;
                  stroke-width: 4px;
                }
              </style>
            </defs>
            <g id="Layer_1-2" data-name="Layer 1">
              <path id="Layer_2-2" data-name="Layer 2" class="cls-1" d="m305.36,1C137.27,1,1,137.27,1,305.36s136.27,304.36,304.36,304.36,304.36-136.27,304.36-304.36S473.46,1,305.36,1Zm16.27,463.59l.07.07h-114.8V198.27c0-14.51-2.54-17.54-22.11-33.57l-16.37-13.93v-4.75h162.74c48.15,0,97.64,22.08,97.64,80.13,0,36.01-22.49,59.84-55.34,69.78v.83c39.55,3.69,69.55,37.26,68.78,76.97,0,69.33-60.32,90.86-120.61,90.86Zm39.45-202.22c7.27-6.95,11.26-16.64,11.01-26.69.5-10.26-3.36-20.25-10.63-27.51-9.66-9.11-19.36-13.48-50.93-13.48h-46.88v80.99h51.59c23.42,0,36.45-4.37,45.84-13.31h0Zm-42.95,61.9h-54.48v91.82h52.21c29.27,0,69.71-4.99,69.71-46.81,0-33.33-21.56-45.02-67.44-45.02Z"/>
            </g>
          </svg>
        </div>
    </div>
    <div class="page page-2">
        <div class="page-header">
            <div class="data-wrapper-partner">
              <div class="custom-company"><img class="logo-img hidden"><span id="partnerName"></span></div>
              <h4>EDR Trial report</h4>
            </div>
            <div class="data-wrapper-client">
              <h4 id="clientNamePage2">Client name</h4>
              <h5>Reporting interval: <span id="reportingPeriodPage2"></span></h5>
            </div>
        </div>
        <div class="page-main-section">
          <div class="page-main-item">
            <h5>Endpoints with EDR</h5>
            <span id="managedEndpoints">0</span>
            <svg class="d-none" width="30" height="40" viewBox="0 0 60 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M30 9.7C35.4 14.7 42.5 17.7 50.3 17.7H50.4001C50.4001 18.7 50.4001 19.7 50.4001 20.8C50.6001 35.2 51 53.1 30 60.9C9.00005 53.1 9.30005 35.1 9.50005 20.7C9.50005 19.6 9.50005 18.6 9.50005 17.6C9.60005 17.6 9.70005 17.6 9.80005 17.6C17.5 17.6 24.6 14.6 30 9.7ZM30 7.5C24.1 13.4 17.2001 16.1 8.10005 16.1C8.10005 31.5 5.10005 53.5 30 62.5C55 53.5 51.9001 31.5 51.9001 16.1C42.8 16.1 35.9 13.4 30 7.5ZM40.5 25.5L27.9 38.1L21.6 31.8L19.9 35.1L27.9 43.1L42.2001 28.8L40.5 25.5Z" fill="#00A71A"/>
            </svg>
          </div>
          <div class="page-main-item">
            <div class="bar"></div>
          </div>
          <div class="page-main-item">
            <h5>Suspicious incidents</h5>
            <span id="suspiciousIncidents">0</span>
            <svg id="suspiciousIncidentsShield" class="d-none" width="30" height="40" viewBox="0 0 60 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M30 9.7C35.4 14.7 42.5 17.7 50.3 17.7H50.4001C50.4001 18.7 50.4001 19.7 50.4001 20.8C50.6001 35.2 51 53.1 30 60.9C9.00005 53.1 9.30005 35.1 9.50005 20.7C9.50005 19.6 9.50005 18.6 9.50005 17.6C9.60005 17.6 9.70005 17.6 9.80005 17.6C17.5 17.6 24.6 14.6 30 9.7ZM30 7.5C24.1 13.4 17.2001 16.1 8.10005 16.1C8.10005 31.5 5.10005 53.5 30 62.5C55 53.5 51.9001 31.5 51.9001 16.1C42.8 16.1 35.9 13.4 30 7.5ZM40.5 25.5L27.9 38.1L21.6 31.8L19.9 35.1L27.9 43.1L42.2001 28.8L40.5 25.5Z" fill="#00A71A"/>
            </svg>
          </div>
          <div class="page-main-item">
            <div class="bar"></div>
          </div>
          <div class="page-main-item">
            <h5>Cross-company incidents</h5>
            <span id="incidentsCrossCompany">0</span>
            <svg id="incidentsCrossCompanyShield" class="d-none" width="30" height="40" viewBox="0 0 60 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M30 9.7C35.4 14.7 42.5 17.7 50.3 17.7H50.4001C50.4001 18.7 50.4001 19.7 50.4001 20.8C50.6001 35.2 51 53.1 30 60.9C9.00005 53.1 9.30005 35.1 9.50005 20.7C9.50005 19.6 9.50005 18.6 9.50005 17.6C9.60005 17.6 9.70005 17.6 9.80005 17.6C17.5 17.6 24.6 14.6 30 9.7ZM30 7.5C24.1 13.4 17.2001 16.1 8.10005 16.1C8.10005 31.5 5.10005 53.5 30 62.5C55 53.5 51.9001 31.5 51.9001 16.1C42.8 16.1 35.9 13.4 30 7.5ZM40.5 25.5L27.9 38.1L21.6 31.8L19.9 35.1L27.9 43.1L42.2001 28.8L40.5 25.5Z" fill="#00A71A"/>
            </svg>
          </div>
        </div>

        <div class="page-secondary-section" id="monitoredResources">
          <h5>Security insights</h5>
          <div class="page-secondary-wrapper">
            <div class="page-secondary-item">
              <span class="icon ds-icon-resource_file"></span>
              <span class="widget-description">Files</span>
              <span class="widget-value" id="files">0</span>
            </div>
            <div class="bar"></div>
            <div class="page-secondary-item">
              <span class="icon ds-icon-entity_IP_domain_DNS_DGA"></span>
              <span class="widget-description">Domains</span>
              <span class="widget-value" id="domains">0</span>
            </div>
            <div class="bar"></div>
            <div class="page-secondary-item">
              <span class="icon ds-icon-registry"></span>
              <span class="widget-description">Registries</span>
              <span class="widget-value" id="registries">0</span>
            </div>
            <div class="bar"></div>
            <div class="page-secondary-item">
              <span class="icon ds-icon-entity_IP_domain_DNS_DGA"></span>
              <span class="widget-description">IPs</span>
              <span class="widget-value" id="ips">0</span>
            </div>
            <div class="bar"></div>
            <div class="page-secondary-item">
              <span class="icon icon-process"></span>
              <span class="widget-description">Processes</span>
              <span class="widget-value" id="processes">0</span>
            </div>
          </div>
        </div>

        <div class="page-third-section" id="thirdSection">
          <div class="section-wrapper">
            <h5>Incidents by severity</h5>
            <div id="incidentsChart" class="chart-incidents"></div>
            <div id="incidentsChartLegend" class="chart-incidents-legend"></div>
            <div class="section-details">Highlights potential risks of a security event, with higher scores reflecting increased risk, as identified by Bitdefender EDR.</div>
          </div>
          <div class="section-wrapper">
            <h5>Top affected devices</h5>
            <div class="top-affected-devices"></div>
            <div class="section-details">Displays the devices in your company with the highest number of security events as identified by Bitdefender EDR.</div>
          </div>
        </div>

        <div class="section-title" id="threatsSectionTitle">
            Threat landcape in <span class="industry">Health</span> | <span class="country">Romania</span>
          </div>
        <div class="page-forth-section" id="fourthSection">
          <div class="section-wrapper">
            <h5>Most commonly exploited resources</h5>
            <div id="chartExploitedResources" class="chart-bars"></div>
            <div class="section-details">As identified by Bitdefender for your country and industry.</div>
          </div>
          <div class="section-wrapper">
            <h5>Most common attack techniques</h5>
            <div id="top5MitreChart"></div>
            <div id="top5MitreChartLegend" class="top-5-mitre-chart-percentages"></div>
            <div class="section-details">As identified by Bitdefender, based on MITRE ATT&CK classification.</div>
          </div>
        </div>
        <div class="page-fifth-section" id="fifthSection">
          <div id="actorsSection" class="section-wrapper">
            <h5>Top active malicious actors</h5>
            <div id="chartActors"></div>
            <div id="chartActorsLegend" class="legend"></div>
            <div class="section-details">As identified by Bitdefender for your country and industry.</div>
          </div>
          <div class="section-wrapper">
            <h5>Top active malicious threat families</h5>
              <div class="chart-threat-families" id="threatFamiliesChart"></div>
            <div class="section-details">As identified by Bitdefender for your country and industry.</div>
          </div>
        </div>
        <div class="page-footer">
            <h6>Powered by
                <svg width="24" height="24" viewBox="0 0 32 32" fill="none" opacity="0.2" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1307_28)">
                  <path d="M25.4 7.8C21.4 7.8 18.3 6.6 15.7 4C13.1 6.6 10.1 7.8 6.1 7.8C6.1 14.5 4.8 24.1 15.8 28C26.8 24.1 25.4 14.5 25.4 7.8ZM12.9 20.5H10.3V11.9H12.8V20.5H12.9ZM21.7 20.5H14V18.7L18.5 13.7H14.4V11.9H21.5V13.6L16.9 18.6H21.6V20.5H21.7Z" fill="black"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_1307_28">
                  <rect width="19.4" height="24" fill="white" transform="translate(6 4)"/>
                  </clipPath>
                  </defs>
                </svg>
              Bitdefender Advanced Threat Intelligence
            </h6>
        </div>
    </div>
  </div>
`;
